import { render } from "./LinkPreviewFileSize.vue?vue&type=template&id=19e7dc56&ts=true"
import script from "./LinkPreviewFileSize.vue?vue&type=script&lang=ts"
export * from "./LinkPreviewFileSize.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__